import Vue from 'vue'
import Vuex from 'vuex'
import user from './modules/user'
import campaign from './modules/campaign'
import createLogger from './logger'

Vue.use(Vuex)

const debug = process.env.NODE_ENV !== 'production'

export default new Vuex.Store({
  modules: {
    user,
    campaign
  },
  strict: debug,
  plugins: debug ? [createLogger()] : []
})
